export const TEST_IDS = {
  addCounterOfferButton: 'add-counter-offer-button',
  counterOfferContainer: 'counter-offer-container',
  counterOfferOverflowMenu: 'counter-offer-overflow-menu',
  counterOfferAmountInput: 'counter-offer-amount-input',
}
